import script from "./TicketReservations.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketReservations.vue?vue&type=script&setup=true&lang=js"

import "./TicketReservations.vue?vue&type=style&index=0&id=983af90c&scoped=true&lang=scss"
script.__scopeId = "data-v-983af90c"

export default script